import React from 'react'
import transactionError from "../../../../../../assets/images/transfer-error.png"
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { appTheme } from '../../../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../../../../Redux/selectors';

const TransferError = ({ onCanelTranfer, isCancelButton,fromAccountType }) => {
  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
  const appThemeData = appTheme(kudzuPlusTrue) 
  const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
  const accountServicesPath = (fromAccountType != undefined && fromAccountType != null)
    ? `/AccountServices/${fromAccountType}`
    : '/AccountServices';
  const manageMoneyPath = '/ManageMoney';
  const supportPhone = t('transfer_error_phone');
  const supportEmail = t('transfer_error_email');
  return (
    <div className=' flex flex-col justify-center items-center w-full'>

          <img src={appThemeData.transactionError} alt="complete" className=' my-16 ' />
          {isTransferMoneyFeatureEnabled ? (
              <div className=' flex flex-col justify-center items-center gap-8 w-full'>

                  <p className='font-hanken-grotesk font-[400] text-[16px] leading-[24px] sm:text-[14px] sm:leading-[22px] md:text-[16px] md:leading-[24px] text-[var(--transferSubHeading-text)] w-full'>
                      {t('please_contact')}
                      <a href={`tel:${supportPhone.replace(/[^\d+]/g, '')}`} className={kudzuPlusTrue ? 'text-[#94C3E8]' : 'text-[#2965FB]'}>{supportPhone}</a>
                      {t('transfer_error_contact_middle')}
                      <a href={`mailto:${supportEmail}`} className={kudzuPlusTrue ? 'text-[#94C3E8]' : 'text-[#2965FB]'}>{supportEmail}</a>
                      {t('transfer_error_contact_suffix')}
                  </p>

                  <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                      <Link to={manageMoneyPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] bg-[#2965FB] text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_manage_money")}</Link>
                  </div>
              </div>
          ) : (
                  <div className=' flex flex-col justify-center items-center w-full'>

                      <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                          <Link to={accountServicesPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] bg-[#2965FB] text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_account_services")}</Link>
                          {isCancelButton &&
                              <button type="button" className="font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] text-[var(--transferBtnTextColor)] cursor-pointer  px-2 py-4 w-full" onClick={() => onCanelTranfer(true)}>{t("cancel_tranfer")}</button>

                          }
                      </div>
                  </div>
          )}

      

    </div>
  )
}

export default TransferError